module.exports = __webpack_public_path__ + "static/media/storage_carousel.9678ad4f.png";